import { observer } from 'mobx-react-lite';
import Popup from '@components/Popups/Popup';
import styles from '@components/Popups/Popups.styles';
import popupStore from '@context/global/mobx/popupStore';
const Popups = () => {
  if (popupStore.popups.length < 1) {
    return null;
  }
  return <div sx={styles.container}>
      <div sx={styles.popupsContainer}>
        {popupStore.popups.map(popup => <Popup key={popup.id} popup={popup} />)}
      </div>
    </div>;
};
export default observer(Popups);